// Default document meta data for the site
export const defaultDocumentMeta = {
    title: "Thunblom Cloud Solutions | Cloud Engineering & Web Development",
    description:
        "Colorado-based cloud systems and software development consultancy empowering small businesses with secure hosting, modern websites, and ongoing support.",
    keywords:
        "Thunblom Cloud Solutions, Denver Colorado, cloud solutions, custom software, WordPress development, AWS, small business websites, security",
    canonicalUrl: "https://thunblom.cloud/",
};
